module.exports = __webpack_public_path__ + "static/background-hearth-36c61c23b22d24cb73f8657dc59efb69.png";